export default "__VITE_ASSET__yXaj6b_t__"